import {
  fullNameUI,
  fullNameSchema,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['household-dependents-custodian-name-title']),
    custodianFullName: fullNameUI(),
  },
  schema: {
    type: 'object',
    properties: {
      custodianFullName: fullNameSchema,
    },
    required: ['custodianFullName'],
  },
};
